export const NAVIGATION_OFFSET_CSS_VARIABLE = '--navigation-offset' as const;
export const NAVIGATION_OFFSET_TRANSITION_CSS_VARIABLE = '--navigation-offset-transition' as const;
